<section class="flex flex-col rounded-md w-full gap-3">
  @if (options()?.header?.show !== false) {
    <lepi-grid-header
      [(align)]="align"
      [(orderBy)]="orderBy"
      [columns]="columns()"
      [rowData]="rowData()"
      [(query)]="query"
      [(selecteds)]="selecteds"
      (export)="handleExport()">
      <ng-content name="[buttons]" />
    </lepi-grid-header>
  }
  @if (options()?.view === 'table' || !options()?.view) {
    <lepi-grid-table [(align)]="align" [(orderBy)]="orderBy" [(selecteds)]="selecteds" />
  } @else {
    <lepi-grid-gallery [(align)]="align" [(orderBy)]="orderBy" />
  }
  <section class="flex w-full justify-between items-center">
    <p class="font-semibold theme-text">
      전체
      <span class="text-primary ml-1">{{ totalItems() | number }}</span>
    </p>
    @if (!options()?.searchOption?.disablePagination) {
      <div class="flex items-center gap-4">
        @if (pageInfo(); as pageInfo) {
          <lepi-pagination [(pageNo)]="pageNo" [pageInfo]="pageInfo" />
        }
        <select class="select focus-within:input-primary" [(ngModel)]="pageSize">
          <option disabled selected>선택</option>
          @for (size of pageSizeOptions; track size) {
            <option [value]="size">{{ size }}</option>
          }
        </select>
      </div>
    }
  </section>
</section>
